angular.module('accordionContractualTransparency.components', [])
    .component('accordionContractualTransparency', {
        templateUrl: "ng/components/accordionContractualTransparency/accordionContractualTransparency.view.html",
        bindings: {},
        controllerAs: 'ContractualTransparencyCtrl',
        controller: function ContractualTransparency($instantService) {
            var self = this;

            self.$onInit = function () {


                $instantService.getPrecontractualTransparency()
                    .then(function (response) {

                        self.precontractualDocuments = response.listPreContractualDocumentPojo
                        console.log('product is: ', response);
                    })
                    .catch(function (err) {
                        console.log('Errore: ', err);
                    })
                    .finally(function () {

                    });
            }

            self.generateContractDownloadLink = function (urlFile) {
                var urlDoc = urlFile;

                return (
                    urlDoc
                );
            };

        }
    });